import { getHospitalId, getToken } from '../../Utils/authUtils';
import { REPORTS } from '../../constant';
import type { HistoryReport } from '../../Utils/measurementHistory';

/**
 * The patient's saved reports, for the measurement-history hover.
 *
 * A plain fetch, not a thunk: the shared `getReportFromPatientIdApi` writes the
 * `getReportFromPatientIdResponse` slice that the patient-report page renders from, and
 * a hover in Express must not change another screen's data.
 */
export async function fetchPatientReportsForHistory(patientId: string): Promise<HistoryReport[]> {
  const response = await fetch(REPORTS.GET_REPORT_FROM_PATIENT_ID_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    body: JSON.stringify({ hospitalId: getHospitalId(), patientId }),
  });
  // The endpoint answers 404 when the patient has no saved reports.
  if (response.status === 404) return [];
  const result = await response.json().catch(() => null);
  if (!response.ok) throw new Error(result?.message || result?.msg || 'Could not load the patient’s reports');
  return Array.isArray(result?.result) ? result.result : [];
}
